module.exports = __webpack_public_path__ + "img/thumb_17.bba75470.jpg";